import { render, staticRenderFns } from "./CountryAndUniversitySelectboxWithFilter.vue?vue&type=template&id=62825e45&"
import script from "./CountryAndUniversitySelectboxWithFilter.vue?vue&type=script&lang=js&"
export * from "./CountryAndUniversitySelectboxWithFilter.vue?vue&type=script&lang=js&"
import style0 from "./CountryAndUniversitySelectboxWithFilter.vue?vue&type=style&index=0&id=62825e45&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports